<template>
  <base-dialog-button 
    :isOpen="dialogOpen" 
    @closeDialog="toggleDialog" 
    :size="mobileVersion ? 'fs' : 'fs-space'" 
    :closable="false" 
    forzeHFull
    :hiddenBackground="true"
    :ariaLabel="$t('wizard.header')" 
    refNameContainer="baseDialogContainerWizard">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('wizard.header')}}</h2>
        </div>
      </div>
    </template>
    <template slot="main">
      <PDFViewerDialog
        :dialogOpen="openGeneratePdfDialog"
        :blobUrl="pdfVisualicer"
        @toggleDialog="toggleGeneratePdfDialog"
        @setFileSigned="setFileSigned"
        :onlyDownload="true"
      />
      <div class="w-full flex flex-col min-h-full dark:bg-staticdarkblue-900 content-wizard"
        style="height: calc(100vh - 500px)">
        <div class="flex h-full overflow-hidden relative mt-6">
          <div class="content-wrapper w-full flex flex-col overflow-hidden relative">
            <div class="flex-none relative" v-if="activeStep !== 1">
              <!-- <h2 class="dark:text-staticdarkblue-200 text-md mb-4 text-center">{{$t('wizard.header')}}</h2> -->
              <el-steps :active="activeStepStepper" finish-status="success" align-center class="mb-2 static-css pl-4 mr-4 step-border-none">
                <!-- Paso 1 Oculto -->
                <!-- <el-step v-if="listaSteps.includes(1)" :title="$t('wizard.step_inicial_title')" icon="el-icon-video-play"></el-step> -->
                <el-step v-if="listaSteps.includes(2)" :title="$t('wizard.step_empresa_title')" 
                  icon="el-icon-office-building">
                </el-step>
                <el-step v-if="listaSteps.includes(3)" :title="$t('wizard.step_cert_title')">
                    <template #icon >
                        <base-icon name="certificates" />
                    </template>
                </el-step>
                <el-step v-if="listaSteps.includes(4) && !isPackageWithoutVerifactu" :title="$t('wizard.step_verifactu_title')">
                    <template #icon>
                        <base-icon name="verifactu" />
                    </template>
                </el-step>
                <el-step v-if="listaSteps.includes(5)" :title="$t('wizard.step_tutorial_title')" 
                  icon="el-icon-video-play">
                </el-step> 
                <!-- Paso final Oculto -->
                <!-- <el-step v-if="listaSteps.includes(6)" :title="$t('wizard.step_end')" icon="el-icon-circle-check"></el-step> -->
              </el-steps>
            </div>
            <div class="content relative flex flex-col flex-initial overflow-y-auto w-full" id="container-steps">
              
              <!-- <div class="m-6 border-2 rounded h-full p-2"> -->
                <div class="ml-8 lg:ml-16 mr-8 lg:mr-16 p-2 form-wrapper">

                  <div v-if="activeStep === 1" class="flex flex-col items-center">
                    <div class="flex flex-col lg:flex-row items-end gap-x-6">
                      <img :src="darkMode ? LogoInvoiZEDark : LogoInvoiZE" alt="InvoiZE" 
                        class="mx-auto w-logo brand"
                        :class="{'mb-6': !isPackageOracle}"
                      />
                      <img :src="LogoOracle" alt="Oracle" v-if="isPackageOracle"
                        class="mx-auto mb-1 w-logo brand w-[17rem]"
                      />
                    </div>
                    <div class="flex flex-col lg:flex-row gap-x-6 ml-8 mr-8 mt-8">
                      <div class="w-full"
                        >
                        <h2 class="dark:text-darkblue-200 font-bold pt-4 pb-4 mb-4 text-4xl text-balance text-center lg:text-left"
                          >
                          {{$t('wizard.step_beginning')}}
                        </h2>
                        <label class="text-xl font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-balance text-center lg:text-left"
                          v-if="!isPackageOracle"
                          >
                          {{$t('wizard.beginning_msg')}}
                        </label>
                        <div v-else class="">
                          <label class="text-xl font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-balance text-center lg:text-left">
                            {{$t('wizard.beginning_msg_oracle_1')}}
                          </label>
                          <label class="text-xl font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-balance text-center lg:text-left">
                            {{$t('wizard.beginning_msg_oracle_2')}}
                          </label>
                          <label class="text-xl font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-balance text-center lg:text-left">
                            {{$t('wizard.beginning_msg_oracle_3')}}
                          </label>
                        </div>
                      </div>
                      <div class="w-full flex justify-center" v-if="!isPackageOracle">
                        <youtube 
                          v-if="videoIdLinkInitial"
                          :video-id="videoIdLinkInitial" 
                          ref="youtube" 
                          style="height: 18rem; max-width: 100%;"
                          :width="isLower1024 ? 400 : 600"
                          resize
                          />
                      </div>
                    </div>
                  </div>

                  <div v-if="activeStep === 2">

                    <el-form
                      :model="formStepEmpresa"
                      :rules="rulesStepEmpresa"
                      ref="ruleformStepEmpresa"
                    >
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 mt-2 text-sm">
                        {{$t('wizard.step_empresa_msg_1')}}
                      </label>
                      <div class="flex gap-x-6 flex-col lg:flex-row">
                        <div class="w-full">
                          <h3 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_empresa')}}</h3>

                          <div class="mb-4">
                              <el-switch class="switch-text break-normal both-switch" 
                              v-model="formStepEmpresa.PersonaFisica" 
                              :active-text="$t('wizard.persona.fisica')" 
                              :inactive-text="$t('wizard.persona.juridica')"
                              inactive-color="var(--primary-800)"
                              >
                              </el-switch>
                          </div>

                          <div v-if="formStepEmpresa.PersonaFisica">
                              <div class="lg:mb-2">
                              <div class="mandatory">
                                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
                                  <el-form-item prop="PersonaFisicaNombre">
                                  <el-input
                                      clearable
                                      class="w-full"
                                      v-model="formStepEmpresa.PersonaFisicaNombre"
                                      maxlength='40'
                                  />
                                  </el-form-item>
                              </div>
                              </div>
                              <div class="lg:mb-2">
                              <div class="mandatory">
                                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('persons_data.firstsurname')}}</label>
                                  <el-form-item prop="PersonaFisicaPrimerApellido">
                                  <el-input
                                      clearable
                                      class="w-full"
                                      v-model="formStepEmpresa.PersonaFisicaPrimerApellido"
                                      maxlength='40'
                                  />
                                  </el-form-item>
                              </div>
                              </div>
                              <div class="lg:mb-2">
                              <div class="mandatory">
                                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('persons_data.secondsurname')}}</label>
                                  <el-form-item prop="PersonaFisicaSegundoApellido">
                                  <el-input
                                    clearable
                                    class="w-full"
                                    v-model="formStepEmpresa.PersonaFisicaSegundoApellido"
                                    maxlength='40'
                                  />
                                  </el-form-item>
                              </div>
                              </div>
                          </div>
                          <div v-else>
                              <div class="lg:mb-2">
                              <div class="mandatory">
                                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('companies.companyName')}}</label>
                                  <el-form-item prop="NombreCIF">
                                  <el-input
                                    clearable
                                    class="w-full"
                                    v-model="formStepEmpresa.NombreCIF"
                                    maxlength='130'
                                  />
                                  </el-form-item>
                              </div>
                              </div>
                          </div>

                          <div class="flex flex-col lg:flex-row gap-x-2">

                            <div class="w-full">
                                <div class="mandatory">
                                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('companies.cif')}}</label>
                                <el-form-item prop="CIF" class="mb-0">
                                  <el-input
                                  clearable
                                  class="w-full"
                                  v-model="formStepEmpresa.CIF"
                                  maxlength='50'
                                  />
                                </el-form-item>
                                </div>
                            </div>

                            <div class="w-full">
                                <div class="mandatory">
                                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.telefono')}}</label>
                                <el-form-item prop="Telefono" ref="Telefono" class="mb-0">
                                  <el-input
                                  clearable
                                  class="w-full"
                                  v-model="formStepEmpresa.Telefono"
                                  maxlength='15'
                                  />
                                </el-form-item>
                                </div>
                            </div>

                          </div>

                        </div>
                        <div class="w-full">
                          <div class="flex items-center mt-2 mb-4">
                          <h3 class="dark:text-darkblue-200 font-bold mb-4">{{$t('address.header')}}</h3>
                          </div>
                          <div class="flex flex-col lg:flex-row gap-x-2 lg:mt-10">
                            <div class="w-full">
                                <div class="mandatory">
                                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.location')}}</label>
                                    <el-form-item prop="Direccion" ref="Direccion">
                                    <el-input
                                        clearable
                                        class="w-full"
                                        v-model="formStepEmpresa.Direccion"
                                        maxlength='80'
                                    />
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="w-full">
                                <div class="mandatory">
                                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.codigo_postal')}}</label>
                                    <el-form-item prop="CodigoPostal" ref="CodigoPostal">
                                    <el-input
                                        clearable
                                        class="w-full"
                                        v-model="formStepEmpresa.CodigoPostal"
                                        maxlength='9'
                                    />
                                    </el-form-item>
                                </div>
                            </div>
                          </div>
                          <div class="lg:mb-2 w-full">
                            <div class="mandatory">
                              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.poblacion')}}</label>
                              <el-form-item prop="Poblacion" ref="Poblacion">
                              <el-input
                                  clearable
                                  class="w-full"
                                  v-model="formStepEmpresa.Poblacion"
                                  maxlength='50'
                              />
                              </el-form-item>
                            </div>
                          </div>
                          <div class="lg:mb-2 w-full">
                              <div class="mandatory">
                                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.provincia')}}</label>
                                  <el-form-item prop="Provincia" ref="Provincia">
                                  <el-input v-if="!isSpain"
                                      clearable
                                      class="w-full"
                                      v-model="formStepEmpresa.Provincia"
                                      maxlength='20'
                                  />
                                  <el-select v-else
                                      class="w-full" 
                                      v-model="formStepEmpresa.Provincia" 
                                      filterable
                                      clearable 
                                      :placeholder="$t('app.select')">
                                      <el-option
                                      v-for="opt in listProvincias"
                                      :key="opt.id"
                                      :label="opt.name"
                                      :value="opt.name">
                                      </el-option>
                                  </el-select>
                                  </el-form-item>
                              </div>
                          </div>
                          <div class="w-full">
                              <div class="mandatory">
                                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('address.pais')}}</label>
                                  <el-form-item prop="Pais" ref="Pais" class="mb-0">
                                  <base-el-select class="w-full" :options="listPaises" v-model="formStepEmpresa.Pais" clearable filterable />
                                  </el-form-item>
                              </div>

                        </div>

                        </div>
                      </div>

                    </el-form>
                  </div>

                  <div v-if="activeStep === 3">
                    <el-form
                      :model="formStepCertificado"
                      :rules="rulesStepCertificado"
                      ref="ruleformStepCertificado"
                    >
                      <h2 v-if="!checkPreloadCert" class="dark:text-darkblue-200 font-bold mt-2 mb-4">
                        {{ checkPreloadPdf ? $t('wizard.step_cert_2') : $t('wizard.step_cert')}}
                      </h2>

                      <label v-if="formStepCertificado.tieneCertificado && !checkPreloadCert" class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm">
                        {{$t('wizard.step_cert_msg_1')}}
                      </label>
                        
                      <div class="mb-2" v-if="!checkPreloadCert && !checkPreloadPdf">
                        <el-switch
                          class="switch-text break-normal"
                          v-model="formStepCertificado.tieneCertificado"
                          :inactive-text="$t('companies.configuration.certificado_zc')"
                          :active-text="$t('wizard.certificado_pfx')"
                        ></el-switch>

                        <base-tip-box v-if="formStepCertificado.tieneCertificado" type="info" :text-content="$t('companies.configuration.certificate')" :links="adviceLinks" />
                        <base-tip-box v-else type="info" :text-content="$t('companies.configuration.firma_delegada.electronic_signature')" :links="adviceLinks" />
                        
                      </div>

                      <div v-if="formStepCertificado.tieneCertificado" class="lg:max-w-[50%]">

                        <div class="lg:mb-2 mt-4" v-if="!checkPreloadCert">
                          <div class="flex -mx-2 flex-col lg:flex-row">
                            <div class="px-2 lg:mb-0">
                              <label class="text-sm font-semibold text-secondary-600 mb-1 block"><base-obligatory-icon/>{{$t('tipos.certificate.pfx_p12')}}</label>
                              <el-form-item prop="file" ref="uploadpfxref">
                                <Upload
                                  ref="upload"
                                  accept=".pfx,.p12"
                                  id="pfxselector"
                                  class="bg-white dark:bg-darkblue-900 dark:bg-darkblue "
                                  :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                                  drag
                                  action="#"
                                  :show-file-list="false"
                                  :multiple="false"
                                  :auto-upload=false
                                  :on-remove="handleRemove"
                                  :on-change="handleChange">
                                  <i class="el-icon-upload"></i>
                                  <p v-if="file.name" class="el-upload__text"><em>{{file.name}}</em></p>
                                  <div v-else class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', 1)"></div>
                                </Upload>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="w-full flex items-center gap-x-2" v-if="file.name">
                            <div class="w-full">
                              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('users.password')}}</label>
                              <el-form-item prop="password">
                                <el-input
                                  clearable
                                  show-password
                                  autocomplete="new-password"
                                  v-model="formStepCertificado.password"
                                  maxlength='255'
                                  class="w-full"
                                />
                              </el-form-item>
                            </div>
                            <base-button 
                              @click.stop.prevent="nextStepValidate" 
                              mode="secondary-phantom-blue" 
                              :text="labelValidate" 
                              :loading="isGeneralLoading" 
                              :disabled="isGeneralLoading" />
                          </div>

                        </div>
                        <div class="flex flex-col gap-x-6 w-full pt-2" v-if="checkPreloadCert">
                          <h3 class="dark:text-darkblue-200 font-bold mb-2 mt-4">{{$t('wizard.step_cert_data')}}</h3>
                          <div class="w-full">
                            <base-ro-input-wrap :label="$t('certificates.name_verbose')" :data="dataCertificate.nombre" class="mb-2"/>
                            <div class="flex gap-x-6 lg:flex-row flex-col">
                              <base-ro-input-wrap :label="$t('certificates.issuer_verbose')" :data="dataCertificate.issuer" class="mb-2 w-full"/>
                              <base-ro-input-wrap :label="$t('certificates.expires_at')" :data="dataCertificate.fechaCaducidad" class="mb-2 w-full"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>

                        <div v-if="!checkPreloadPdf">
                        
                          <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm">
                            {{$t('wizard.step_cert_msg_2')}}
                          </label>

                          <div class="mb-2">
                            <el-switch
                              class="switch-text break-normal"
                              v-model="formStepCertificado.generatedPdf"
                              :inactive-text="$t('wizard.step_cert_zc_opt1')"
                              :active-text="$t('wizard.step_cert_zc_opt2')"
                            ></el-switch>
                          </div>

                          <label v-if="formStepCertificado.generatedPdf" class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm">
                            {{$t('wizard.step_cert_msg_5')}}
                          </label>


                          <div class="flex gap-x-6 flex-col lg:flex-row mt-4">

                            <div class="w-full" v-if="!formStepCertificado.PersonaFisica && !formStepCertificado.generatedPdf">
                              <div class="flex items-center gap-x-2 mt-2 mb-4">
                                <h3 class="dark:text-darkblue-200 font-bold ">{{$t('companies.configuration.firma_delegada.datos_representante')}}</h3>
                                <base-tooltip-icon-html
                                  size="sm" 
                                  :content="contentTooltipDatosFirmante"
                              />
                              </div>
                              <div class="mandatory w-full">
                                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('contacto.ContactPersons_short')}}</label>
                                <el-form-item prop="NombreApellidos">
                                  <el-input
                                      clearable
                                      class="w-full"
                                      v-model="formStepCertificado.NombreApellidos"
                                      maxlength='100'
                                  />
                                </el-form-item>
                              </div>
                              <div class="mandatory w-full">
                                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('agenda.nif_nie')}}</label>
                                <el-form-item prop="NIF">
                                  <el-input
                                      clearable
                                      class="w-full"
                                      v-model="formStepCertificado.NIF"
                                      maxlength='20'
                                  />
                                </el-form-item>
                              </div>

                            </div>

                            <div class="w-full" v-if="!formStepCertificado.PersonaFisica && !formStepCertificado.generatedPdf">

                              <h3 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('companies.configuration.firma_delegada.domicilio_fiscal')}}</h3>
                            
                              <div class="mandatory w-full">
                                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('companies.configuration.firma_delegada.municipio')}}</label>
                                <el-form-item prop="Municipio">
                                  <el-input
                                      clearable
                                      class="w-full"
                                      v-model="formStepCertificado.Municipio"
                                      maxlength='100'
                                  />
                                </el-form-item>
                              </div>

                              <div class="flex items-center gap-x-2 w-full">
                                <div class="mandatory w-full">
                                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('companies.configuration.firma_delegada.via_publica')}}</label>
                                  <el-form-item prop="ViaPublica">
                                    <el-input
                                        clearable
                                        class="w-full"
                                        v-model="formStepCertificado.ViaPublica"
                                        maxlength='100'
                                    />
                                  </el-form-item>
                                </div>
                                  <div class="mandatory">
                                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('companies.configuration.firma_delegada.numero')}}</label>
                                    <el-form-item prop="NumeroViaPublica">
                                      <el-input
                                      clearable
                                      v-model="formStepCertificado.NumeroViaPublica"
                                      maxlength='10'
                                      />
                                    </el-form-item>
                                  </div>
                              </div>

                            </div>

                            <div class="w-full lg:mt-2" v-if="formStepCertificado.generatedPdf">
                              <div class="flex -mx-2 flex-col lg:flex-row gap-x-2 items-center">
                                <div class="px-2 lg:mb-0">
                                  <label class="text-sm font-semibold text-secondary-600 mb-1 block"><base-obligatory-icon/>{{$t('companies.configuration.firma_delegada.subir_pdf_firma')}}</label>
                                  <el-form-item prop="filePdf" ref="uploadpdfref">
                                    <Upload
                                      ref="uploadpdf"
                                      accept=".pdf"
                                      id="pdfselector"
                                      class="bg-white dark:bg-darkblue-900 dark:bg-darkblue "
                                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                                      drag
                                      action="#"
                                      :show-file-list="false"
                                      :multiple="false"
                                      :auto-upload=false
                                      :on-remove="handleRemovePdf"
                                      :on-change="handleChangePdf">
                                      <i class="el-icon-upload"></i>
                                      <p v-if="filePdf.name" class="el-upload__text"><em>{{filePdf.name}}</em></p>
                                      <div v-else class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', 1)"></div>
                                    </Upload>
                                  </el-form-item>
                                </div>
                                <div class="px-2 lg:mb-0 text-center w-full flex justify-center" v-if="showInfoSucessSignCert">
                                  <base-tip-box 
                                    type="info" 
                                    :text-content="$t('wizard.step_cert_msg_6')" 
                                    />
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div v-else>
                          <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm">
                            {{$t('companies.configuration.firma_delegada.delegacion_firmada')}}
                          </label>
                        </div>
                      </div>

                    </el-form>
                  </div>

                  <div v-if="activeStep === 4">
                    
                    <el-form
                      :model="formStepVertifactu"
                      :rules="rulesStepVerifactu"
                      ref="ruleformStepVertifactu"
                    >
                      <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_verifactu')}}</h2>
                      <base-tip-box 
                        v-if="!isPackageOracle"
                        type="warning" 
                        :text-content="$t('wizard.step_verifactu_msg_0')"
                        />
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm">
                        {{$t('wizard.step_verifactu_msg_1')}}
                      </label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_verifactu_msg_2')}}
                        <a :href="verifactuLink" target="_blank" class="underline text-primary dark:text-darkblue-50">
                          {{$t('wizard.step_verifactu_msg_3')}}
                        </a>
                      </label>
                      <div class="flex gap-x-6 flex-col lg:flex-row">
                        <div class="w-full">
                          <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.tbaiconfig_regimen') }}</label>
                          <div class="lg:mb-2">
                            <el-form-item prop="tipoRegimen">
                              <el-select class="w-full z-10" 
                                v-model="formStepVertifactu.tipoRegimen" 
                                :options="tiposRegimen" 
                                clearable 
                                filtrable>
                                <el-option
                                  v-for="opt in tiposRegimen"
                                  :key="opt.id"
                                  :label="opt.name"
                                  :value="opt.id">
                                  <el-popover v-if="showPopover(opt.id)"
                                    placement="top-start"
                                    :open-delay="600"
                                    trigger="hover"
                                    :content="opt.long"
                                    width="500"
                                    popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200 text-justify"
                                  >
                                    <span slot="reference" class="option-text">{{ opt.name }}</span>
                                  </el-popover>
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div>
                            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('verifactu.invoice_type.entity_name') }}</label>
                            <el-form-item prop="tipoFactura">
                              <base-el-select class="w-full" v-model="formStepVertifactu.tipoFactura" :options="tiposFacturas" clearable filtrable />
                            </el-form-item>
                          </div>
                          <div>
                            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('verifactu.verifactu_rectificativa_type.entity_name') }}</label>
                            <el-form-item prop="tipoFacturaRectificativa">
                              <base-el-select class="w-full" v-model="formStepVertifactu.tipoFacturaRectificativa" :options="tiposFacturasRectificativas" clearable filtrable />
                            </el-form-item>
                          </div>
                        </div>
                        <div class="w-full">
                          <div>
                            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('verifactu.verifactu_exenta_type.entity_name') }}</label>
                            <el-form-item prop="tipoExenta">
                              <base-el-select class="w-full" v-model="formStepVertifactu.tipoExenta" :options="tiposExenta" clearable filtrable />
                            </el-form-item>
                          </div>
                          <div>
                            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.tbaiconfig_no_exenta') }}</label>
                            <el-form-item prop="tipoNoExenta">
                              <base-el-select class="w-full" v-model="formStepVertifactu.tipoNoExenta" :options="tiposNoExenta" clearable filtrable />
                            </el-form-item>
                          </div>
                          <div>
                            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.tbaiconfig_no_sujeta') }}</label>
                            <el-form-item prop="tipoNoSujeta">
                              <base-el-select class="w-full" v-model="formStepVertifactu.tipoNoSujeta" :options="tiposNoSujeta" clearable filtrable />
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                    </el-form>
                  </div>

                  <div v-if="activeStep === 5">
                    <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_tutorial')}}</h2>
                    <div v-if="!isPackageOracle">
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_tutorial_msg_1')}}
                      </label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_tutorial_msg_2')}}
                      </label>
                    </div>
                    <div v-else>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_tutorial_msg_oracle_1')}}
                      </label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_tutorial_msg_oracle_2')}}
                      </label>
                    </div>
                    <div class="flex flex-col items-center w-full">
                      <youtube 
                        v-if="videoIdLink"
                        :video-id="videoIdLink" 
                        ref="youtube" 
                        style="height: 18rem;"
                        :width="isLower1024 ? 400 : 600"
                        resize
                        />
                    </div>
                  </div>

                  <div v-if="activeStep === lastStep">
                    <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_end')}}</h2>
                    <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                      {{$t('wizard.end_msg')}}
                    </label>

                    <div v-if="!isPackageOracle">
                      <label v-if="!cerrarAlFinalizar" class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.end_msg2')}}
                      </label>
                      <label v-if="cerrarAlFinalizar" class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.end_msg3')}}
                      </label>
                    </div>
                    <div v-else>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">{{$t('wizard.end_msg_oracle_1')}}</label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        <p>• {{$t('wizard.end_msg_oracle_2')}}</p>
                        <p>• {{$t('wizard.end_msg_oracle_3')}}</p>
                      </label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">{{$t('wizard.end_msg_oracle_4')}}</label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">{{$t('wizard.end_msg_oracle_5')}}</label>
                    </div>

                  </div>

                </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex space-x-2 px-2 bg-white py-1 mt-auto dark:bg-darkblue-900 justify-between w-full items-center">
        <base-button-responsive @click="logout" mode="secondary-phantom-blue" icon="logout" :text="$t('app.exit')" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        <div class="flex">
          <base-button-responsive v-if="!desactiveBackStep" @click="backStep" mode="secondary-phantom-blue" icon="chevronleft" :text="labelBackStep" class="mr-2" :loading="isGeneralLoading" :disabled="isGeneralLoading" />

          <base-button-responsive 
            v-if="activeStep == 3 && (checkPreloadCert || checkPreloadPdf)" 
            @click.stop.prevent="resetFormCert" 
            mode="secondary-phantom-blue" 
            icon="cross"
            :text="$t('wizard.step_cert_reset')" 
            class="mr-2"
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading" />
          <base-button-responsive 
            v-if="activeStep == 3 && !formStepCertificado.tieneCertificado && !checkPreloadPdf && !formStepCertificado.generatedPdf" 
            @click.stop.prevent="loadGeneratePdfDialog" 
            mode="secondary-phantom-blue" 
            icon="detail"
            :text="$t('companies.configuration.firma_delegada.generar_pdf_delegacion_firma')" 
            class="mr-2"
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading" />
          <base-button-responsive 
            v-if="activeStep == 3 && !formStepCertificado.tieneCertificado && checkPreloadPdf" 
            @click.stop.prevent="downloadPdfSigned" 
            mode="secondary-phantom-blue" 
            icon="download"
            :text="$t('companies.configuration.firma_delegada.descargar_delegacion_firma_firmado')" 
            class="mr-2"
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading" />

          <base-button-responsive 
            v-if="activeStep == 3 && (isPackageWithoutVerifactu || isPackageOracle)" 
            @click="skipStep" 
            mode="secondary-phantom-blue" 
            icon="chevronright" 
            :text="$t('app.skip')" 
            class="mr-2" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading" 
            />
          <base-button-responsive v-if="enableNextStep" @click="nextStep" mode="secondary-phantom-blue" icon="chevronright" :text="labelNextStep" class="mr-2" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button
            v-if="activeStep === 1"
            @click="nextStep" 
            class="mt-4"
            mode="primary" 
            :text="$t('wizard.beginning_msg_btn')"
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading" 
            />

          <base-button-responsive v-if="desactiveNextStep && cerrarAlFinalizar" @click="finishStep(true)" mode="secondary-phantom-blue" icon="check" :text="$t('wizard.finish_step2')" class="mr-2" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="desactiveNextStep && !cerrarAlFinalizar" @click="finishStep(false)" mode="secondary-phantom-blue" icon="check" :text="$t('wizard.finish_step')" class="mr-2" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        </div>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import moment from 'moment'
import { i18n } from '@/i18n'
import { Upload } from 'element-ui'
import BaseDialogButton from '../base/BaseDialogButton.vue'
import BaseObligatoryIcon from '../base/BaseObligatoryIcon.vue'
import PDFViewerDialog from '@/components/pdf/PDFViewerDialog.vue'

// Step Aux
import { updateStepWizard } from '@/services/wizard/updateStepWizard' 

// Step Inicial
import { getvideobienvenida } from '@/services/wizard/getvideobienvenida'  

// Step Empresa
import { getEmpresaWizard } from '@/services/wizard/getEmpresaWizard' 
import { updateEmpresaWizard } from '@/services/wizard/updateEmpresaWizard' 

// Step Cert
import { getpdffirmadelegada } from '@/services/wizard/getpdffirmadelegada' 
import { getdatoscertificado } from '@/services/wizard/getdatoscertificado'   
import { getPfxData } from '@/services/wizard/getPfxData' 
import { modificarCertificado } from '@/services/wizard/modificarCertificado'  

// Step Verifactu
import { getdatosverifactu } from '@/services/wizard/getdatosverifactu' 
import { modificarconfigverifactu } from '@/services/wizard/modificarconfigverifactu' 
import { getpdfverifactu } from '@/services/wizard/getpdfverifactu'  

// Step Tutorial
import { getVideoTutorial } from '@/services/wizard/getVideoTutorial'  

import LogoInvoiZE from '@/assets/img/invoize/logo-invoize.svg'
import LogoInvoiZEDark from '@/assets/img/invoize/logo-invoize-dark.svg'
import LogoOracle from '@/assets/img/oracle.png'

export default
{
  name: 'wizard-dialog',
  components: {
    BaseDialogButton,
    Upload,
    BaseObligatoryIcon,
    PDFViewerDialog,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    dataWizard: {
      default: null
    }
  },
  data: function () {
    return {
      verifactuLink: 'https://www.zerocoma.com/',
      isOpen: this.dialogOpen,
      isLoadedData: false,
      licenseReaded: false,

      LogoInvoiZE: LogoInvoiZE,
      LogoInvoiZEDark: LogoInvoiZEDark,
      LogoOracle: LogoOracle,

      autoSignPdf: false,
      openGeneratePdfDialog: false,
      pdfVisualicer: null,
      generatingPdf: false,
      checkPreloadPdf: false,
      namePdfSigned: i18n.t('wizard.step_cert_name_pdf_signed'),

      videoIdLinkInitial: null,
      videoIdLink: null,

      // Steps
      activeStep: 0,
      lastStep: 0,

      adviceLinks: {
        findCert: {
          text: i18n.t('app.here'), 
          url: 'https://www.zerocoma.com/wp-content/uploads/2020/07/Guia-para-encontrar-tu-certificado.pdf' 
        },
        faqFNMT: {
          text: i18n.t('app.link'), 
          url: 'https://www.sede.fnmt.gob.es/preguntas-frecuentes/exp-imp-y-elim-de-certificados' 
        },
        downloadAutoFirma: {
          text: i18n.t('app.here'), 
          url: 'https://firmaelectronica.gob.es/ciudadanos/descargas' 
        }
      },

      formStepEmpresa: {
        CIF: '',
        NombreCIF: '',
        PersonaFisica: false,
        PersonaFisicaNombre: null,
        PersonaFisicaPrimerApellido: null,
        PersonaFisicaSegundoApellido: null,
        Telefono: null,

        Direccion: null,
        CodigoPostal: null,
        Poblacion: null,
        Provincia: null,
        Pais: 'ESP',
      },

      formStepCertificado: {
        tieneCertificado: false,
        generatedPdf: false,
        password: '',
        NombreApellidos: '',
        NIF: '',
        Municipio: '',
        ViaPublica: '',
        NumeroViaPublica: '',
        PersonaFisica: false,
      },

      formStepVertifactu: {
        tipoRegimen: '',
        tipoFactura: '',
        tipoFacturaRectificativa: '',
        tipoExenta: '',
        tipoNoExenta: '',
        tipoNoSujeta: '',
      },

      // Aux Step 3
      file: {
        name: '',
        b64: ''
      },
      filePdf: {
        name: '',
        b64: ''
      },
      dataCertificate: {
        issuer: '',
        nombre: '',
        fechaCaducidad: '',
        serial: '',
      },
      
      // Reglas
      rulesStepEmpresa: {
        NombreCIF: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        CIF: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        PersonaFisicaNombre: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        PersonaFisicaPrimerApellido: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        PersonaFisicaSegundoApellido: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Telefono: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Direccion: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        CodigoPostal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur',
          },
          {
            required: true,
            message: i18n.t('validation.length_number') + i18n.tc('app.n_character', 5),
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!this.isSpain) {
                callback()
              } else {
                var onlyFiveNumbers = /^\d{5}$/
                if (!onlyFiveNumbers.test(value)) {
                  callback(new Error())
                } else {
                  callback()
                }
              }
            }
          },
        ],
        Poblacion: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Provincia: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Pais: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          },
        ],
      },

      rulesStepCertificado: {
        NombreApellidos: [
          { required: true, validator: this.validatorGeneratingPdf },
        ],
        NIF: [
          { required: true, validator: this.validatorGeneratingPdf },
        ],
        Municipio: [
          { required: true, validator: this.validatorGeneratingPdf },
        ],
        ViaPublica: [
          { required: true, validator: this.validatorGeneratingPdf },
        ],
        NumeroViaPublica: [
          { required: true, validator: this.validatorGeneratingPdf },
        ],
        password: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        general: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        file: [
          {
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.generatingPdf) {
                callback()
              } else if (!this.file.name) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.pfx', '.p12'], true) }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.generatingPdf) {
                callback()
              } else if (!this.file.name || this.file.name.length < 5 || 
                (this.file.name.substr(this.file.name.length - 4).toUpperCase() !== '.PFX' && this.file.name.substr(this.file.name.length - 4).toUpperCase() !== '.P12')) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: this.listToCommaString(['.pfx', '.p12'], true) })))
              } else {
                callback()
              }
            }
          }
        ],
        filePdf: [
          {
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.generatingPdf) {
                callback()
              } else if (!this.filePdf.name) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.pdf' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (this.generatingPdf) {
                callback()
              } else if (!this.filePdf.name || this.filePdf.name.length < 5 || this.filePdf.name.substr(this.filePdf.name.length - 4).toUpperCase() !== '.PDF') {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.pdf' })))
              } else {
                callback()
              }
            }
          }
        ],
      },

      rulesStepCertificadoSubmit: {
        password: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        general: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        file: [
          {
            required: false,
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
          },
        ],
      },

      rulesStepVerifactu: {
        tipoRegimen: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoFactura: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoFacturaRectificativa: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoExenta: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoNoExenta: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoNoSujeta: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ]
      },
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    this.isLoadedData = true
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.activeStep = this.dataWizard?.CurrentStep
        this.lastStep = this.dataWizard?.ListaSteps[this.dataWizard?.ListaSteps.length -1]
      } 
    },
    // Control de carga inicial
    activeStep: async function (value, oldValue) {
      if (value === 1) {
        const data = await this.downloadDataStepInitial()
        this.setDataStepInitial(data.Respuesta)
      } else if (value === 2) {
        const data = await this.downloadDataStepEmpresa()
        this.setDataStepEmpresa(data.cifEmpresa)
      } else if (value === 3) {
        const data = await this.downloadDataStepCert()
        this.setDataStepCert(data)
      } else if (value === 4) {
        const data = await this.downloadDataStepVertifactu()
        this.setDataStepVerifactu(data.respuesta)
      } else if (value === 5) {
        const data = await this.downloadDataStepTutorial()
        this.setDataStepTutorial(data.Respuesta)
      }
    }
  },
  computed: {
    showInfoSucessSignCert () {
      return this.filePdf.b64 && this.formStepCertificado.generatedPdf && this.autoSignPdf
    },
    isPackageOracle () {
      return [10].includes(this.dataWizard?.idPaqueteContratacion)
    },
    isPackageICAM () {
      return [4, 5, 6].includes(this.dataWizard?.idPaqueteContratacion)
    },
    isPackageWithoutVerifactu () {
      return [7, 8, 9].includes(this.dataWizard?.idPaqueteContratacion)
    },
    contentTooltipDatosFirmante () {
      return `${this.$i18n.t('wizard.step_cert_tooltip_1')}: 
<br/>- ${this.$i18n.t('wizard.step_cert_tooltip_2')}
<br/>- ${this.$i18n.t('wizard.step_cert_tooltip_3')}`
    },
    checkPreloadCert () {
      return this.dataCertificate?.serial
    },
    listProvincias: function () {
      return this.$store.getters['config/PROVINCIAS']
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    }, 
    isSpain: function () {
      return this.formStepEmpresa.Pais.toUpperCase() === 'ESP'
    },
    activeStepStepper () {
      return this.activeStep - 2
    },
    enableNextStep () {
      if (this.desactiveNextStep) return false
      if (this.activeStep === 1) return false

      if (this.activeStep === 3) {
        if (this.formStepCertificado.tieneCertificado) {
          if (!this.dataCertificate?.fechaCaducidad) return false
        } else {
          if (!this.checkPreloadPdf && !this.formStepCertificado.generatedPdf) return false
          if (!this.filePdf.b64) return false
        }
      }

      return true
    },
    listaSteps () {
      return this.dataWizard?.ListaSteps || []
    },
    cerrarAlFinalizar () {
      return this.dataWizard?.CerrarAlFinalizar || false
    },
    desactiveBackStep () {
      return this.activeStep <= 1
    },
    desactiveNextStep () {
      return this.lastStep <= this.activeStep
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    labelBackStep () {
      return this.$t('wizard.back_step')
    },
    labelValidate () {
      return this.$t('app.validate') 
    },
    labelNextStep () {
      return this.$t('wizard.next_step')
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    tiposRegimen: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_REGIMEN']
    },
    tiposFacturas: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_FACTURAS']
    },
    tiposFacturasRectificativas: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_FACTURAS_RECTIFICATIVAS']
    },
    tiposExenta: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_EXENTA']
    },
    tiposNoExenta: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_NO_EXENTA']
    },
    tiposNoSujeta: function () {
      return this.$store.getters['config/TIPOS_VERIFACTU_NO_SUJETA']
    },
  },
  methods: {
    /// Style
    resetScroll () {
      setTimeout(() => {
        document
          .getElementById('container-steps')
          .scrollTo({ top: 0, behavior: 'smooth' })
      }, 100)
    },
    toggleDialog: async function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    genericNextStepHandler: async function (idPasoActual = -1) {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await updateStepWizard({ idPasoActual: idPasoActual })
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          if (idPasoActual === 3 && !this.isPackageOracle) this.activeStep = this.activeStep + 1
          this.activeStep = this.activeStep + 1
          this.resetScroll()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadPdfSigned () {
      const base64 = this.filePdf.b64.replace(/^data:application\/pdf;base64,/, '') 
      const blob = this.base64ToBlob(base64, 'application/pdf')

      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = decodeURI(this.namePdfSigned)
      link.click()

      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(link.href)
    },
    setFileSigned (base64data) {
      this.filePdf = {
        name: this.namePdfSigned,
        b64: base64data
      }
      this.formStepCertificado.generatedPdf = true
      this.autoSignPdf = true
    },
    loadGeneratePdfDialog () {
      this.generatingPdf = true
      this.getPDFDelegacionFirma()
    },
    toggleGeneratePdfDialog () {
      this.openGeneratePdfDialog = !this.openGeneratePdfDialog
    },
    getPDFDelegacionFirma: async function () {
      this.$refs.ruleformStepCertificado.validate(async valid => {
        if (valid) {
          try {
            this.$store.commit('setIsLoading', true)
            const response = await getpdffirmadelegada({
              NombreApellidos: this.formStepCertificado.NombreApellidos,
              NIF: this.formStepCertificado.NIF,
              Municipio: this.formStepCertificado.Municipio,
              ViaPublica: this.formStepCertificado.ViaPublica,
              NumeroViaPublica: this.formStepCertificado.NumeroViaPublica,
            })
            this.pdfVisualicer = response.data
            this.toggleGeneratePdfDialog()
          } catch (error) {
            this.doFeedback()
          } finally {
            this.$store.commit('setIsLoading', false)
            this.generatingPdf = false
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
          this.generatingPdf = false
        }
      })
    },
    validatorGeneratingPdf: function (rule, value, callback) {
      if (this.generatingPdf) {
        if (value) callback()
        else callback(new Error(i18n.t('validation.complete')))
      } else {
        callback()
      }
    },
    backStep () {
      if (this.desactiveBackStep) return
      else {
        // Nos saltamos el step de vertifactu si el paquete no lo tiene y estamos en ese paso, o el step de certificado si el paquete es oracle y estamos en ese paso
        if (this.isPackageWithoutVerifactu && this.activeStep === 5) this.activeStep = this.activeStep - 1
        // Skip del skip // Nos saltamos el step de certificado si el paquete es oracle y estamos en ese paso, ya que no se muestra ese paso para oracle, pero el número de step sí avanza al siguiente, por lo que al volver atrás desde el 4 al 3, si es oracle, se tendría que volver al 2 directamente, saltándose el 3 que es el de certificado
        // if (this.isPackageOracle && this.activeStep === 4) this.activeStep = this.activeStep - 1
        this.activeStep = this.activeStep - 1
      }

      this.resetScroll()
    },
    nextStep () {
      if (this.desactiveNextStep) return
      if (this.activeStep === 1) this.submitValidStepInicial()
      else if (this.activeStep === 2) this.submitValidStepEmpresa()
      else if (this.activeStep === 3) this.submitValidStepCert()
      else if (this.activeStep === 4) this.submitValidStepVertifactu()
      else if (this.activeStep === 5) this.submitValidStepTutorial()
    },
    skipStep () {
      this.genericNextStepHandler(3)
    },
    finishStep: async function (logout = false) {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await updateStepWizard({ idPasoActual: 6 })
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          if (logout) this.logout()
          else this.toggleDialog()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    logout () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.$emit('toggleDialogClose')
      this.$store.dispatch('auth/logout')
    },
    // Call handlers
    submitValidStepInicial: async function () {
      await this.genericNextStepHandler(1)
    },
    submitValidStepEmpresa: async function () {
      this.$refs.ruleformStepEmpresa.validate(async valid => {
        if (valid) {
          try {
            this.$store.commit('setIsLoading', true)
            const payload = {
              CIF: this.formStepEmpresa.CIF,
              RazonSocial: this.formStepEmpresa.NombreCIF,
              PersonaFisica: this.formStepEmpresa.PersonaFisica,
              PersonaFisicaNombre: this.formStepEmpresa.PersonaFisica ? this.formStepEmpresa.PersonaFisicaNombre : null,
              PersonaFisicaPrimerApellido: this.formStepEmpresa.PersonaFisica ? this.formStepEmpresa.PersonaFisicaPrimerApellido : null,
              PersonaFisicaSegundoApellido: this.formStepEmpresa.PersonaFisica ? this.formStepEmpresa.PersonaFisicaSegundoApellido : null,
              Telefono: this.formStepEmpresa.Telefono,

              Direccion: this.formStepEmpresa.Direccion,
              CodigoPostal: this.formStepEmpresa.CodigoPostal,
              Poblacion: this.formStepEmpresa.Poblacion,
              Provincia: this.formStepEmpresa.Provincia,
              CodigoPais: this.formStepEmpresa.Pais,
            }
            const response = await updateEmpresaWizard(payload)
            if (response.blnError) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.updated_data_msg'), 'success')
              // Skip del skip // Nos saltamos el step de certificado si el paquete es oracle, ya que no se muestra ese paso para oracle, pero el número de step sí avanza al siguiente, por lo que al avanzar desde el 2 al 3, si es oracle, se tendría que avanzar al 4 directamente, saltándose el 3 que es el de certificado
              // if (this.isPackageOracle) this.activeStep = this.activeStep + 1
              this.activeStep = this.activeStep + 1
              this.resetScroll()
            }
          } catch (error) {
            this.doFeedback()
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
    submitValidStepCert: async function () {
      this.$refs.ruleformStepCertificado.validate(async valid => {
        if (valid) {
          try {
            this.$store.commit('setIsLoading', true)
            const payload = { 
              base64: this.formStepCertificado.tieneCertificado ? this.file.b64 : null,
              pwd: this.formStepCertificado.tieneCertificado ? this.formStepCertificado.password: null,
              SerialNumber: this.formStepCertificado.tieneCertificado ? this.dataCertificate?.serial : null,
              Base64PDFFirmado: !this.formStepCertificado.tieneCertificado ? this.filePdf.b64 : null,
            }
            
            const response = await modificarCertificado(payload)
            if (response.blnError) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.updated_data_msg'), 'success')
              // Nos saltamos el step de vertifactu si el paquete no lo tiene
              if (this.isPackageWithoutVerifactu) this.activeStep = this.activeStep + 1
              this.activeStep = this.activeStep + 1
              this.resetScroll()
            }
          } catch (error) {
            this.doFeedback()
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
    // Validacion de los certificados en el Step 3
    nextStepValidate () {
      setTimeout(() => {
        this.$refs.ruleformStepCertificado.validate(async valid => {
          if (valid) {
            try {
              this.$store.commit('setIsLoading', true)
              const payload = { base64: '', pwd: '' }
              payload.base64 = this.file.b64
              payload.pwd = this.formStepCertificado.password

              const response = await getPfxData(payload)
              if (response.blnError) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
              } else {
                this.setDataStepCert(response.datosCertificadoCIF)
              }
            } catch (error) {
              this.doFeedback()
            } finally {
              this.$store.commit('setIsLoading', false)
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      }, 500)
    },
    submitValidStepVertifactu: async function () {
      this.$refs.ruleformStepVertifactu.validate(async valid => {
        if (valid) {
          try {
            this.$store.commit('setIsLoading', true)
            const payload = {
              ClaveRegimenEspecial: this.formStepVertifactu.tipoRegimen,
              TipoFactura: this.formStepVertifactu.tipoFactura,
              TipoRectificativa: this.formStepVertifactu.tipoFacturaRectificativa,
              TipoExenta: this.formStepVertifactu.tipoExenta,
              TipoNoExenta: this.formStepVertifactu.tipoNoExenta,
              TipoNoSujeta: this.formStepVertifactu.tipoNoSujeta,
            }
            const response = await modificarconfigverifactu(payload)
            if (response.blnError) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.updated_data_msg'), 'success')
              this.activeStep = this.activeStep + 1
              this.resetScroll()
            }
          } catch (error) {
            this.doFeedback()
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
    submitValidStepTutorial: async function () {
      await this.genericNextStepHandler(5)
    },
    downloadDataStepEmpresa: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getEmpresaWizard()
        if (res.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataStepCert: async function () {
      try {
        this.$store.commit('setIsLoading', true)

        // Data
        const res = await getdatoscertificado()
        if (res.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        } else {
          this.formStepCertificado.PersonaFisica = res?.certificado?.PersonaFisica
          if (res?.certificado?.Base64PDFFirmado) {
            this.checkPreloadPdf = true
            this.filePdf.b64 = res?.certificado?.Base64PDFFirmado
            this.filePdf.name = this.namePdfSigned
          }
          this.formStepCertificado.tieneCertificado = res?.certificado?.SerialNumber

          /// Certificado propio por defecto para ICAM
          // Si no tiene nada configurado, si es ICAM le activamos por defecto certificado propio
          if (!res?.certificado?.Base64PDFFirmado && !res?.certificado?.SerialNumber) {
            this.formStepCertificado.tieneCertificado = this.isPackageICAM
          }

          return {
            datosCertificadoVinculado: {
              CommonName: res.certificado.CommonName,
              FechaCaducidad: res.certificado.ExpirationDate,
              SerialNumber: res.certificado.SerialNumber,
            },
            Emisor: res.certificado.Emisor,
            Base64PDFFirmado: res.certificado.Base64PDFFirmado,
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataStepVertifactu: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        // Enlace
        const resEnlace = await getpdfverifactu()
        this.verifactuLink = resEnlace.Respuesta
        
        // Data
        const res = await getdatosverifactu()
        if (res.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataStepTutorial: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getVideoTutorial()
        if (res.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataStepInitial: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getvideobienvenida()
        if (res.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    // Setters
    setDataStepEmpresa: function (data) {
      if (data) {
        this.formStepEmpresa.CIF = data.CIF || ''
        this.formStepEmpresa.NombreCIF = data.RazonSocial || ''
        this.formStepEmpresa.PersonaFisica = data.PersonaFisica || false
        this.formStepEmpresa.PersonaFisicaNombre = data.PersonaFisicaNombre || null
        this.formStepEmpresa.PersonaFisicaPrimerApellido = data.PersonaFisicaPrimerApellido || null
        this.formStepEmpresa.PersonaFisicaSegundoApellido = data.PersonaFisicaSegundoApellido || null
        this.formStepEmpresa.Telefono = data.Telefono || null

        this.formStepEmpresa.Direccion = data.Direccion || null
        this.formStepEmpresa.CodigoPostal = data.CodigoPostal || null
        this.formStepEmpresa.Poblacion = data.Poblacion || null
        this.formStepEmpresa.Provincia = data.Provincia || null
        this.formStepEmpresa.Pais = data.CodigoPais || 'ESP'
      }
    },
    setDataStepCert: function (data) {
      if (data) {
        this.dataCertificate.issuer = data.Emisor || null
        this.dataCertificate.nombre = data.datosCertificadoVinculado?.CommonName || null
        this.dataCertificate.fechaCaducidad = data.datosCertificadoVinculado?.FechaCaducidad ? moment(data?.datosCertificadoVinculado?.FechaCaducidad).format('DD-MM-yyyy HH:mm') : null
        this.dataCertificate.serial = data.datosCertificadoVinculado?.SerialNumber || null
        this.dataCertificate.Base64PDFFirmado = data.Base64PDFFirmado || null
      }
      this.autoSignPdf = false
    },
    setDataStepVerifactu: function (data) {
      if (data) {
        this.formStepVertifactu.tipoRegimen = data.ClaveRegimenEspecial || ''
        this.formStepVertifactu.tipoFactura = data.TipoFactura || ''
        this.formStepVertifactu.tipoFacturaRectificativa = data.TipoRectificativa || ''
        this.formStepVertifactu.tipoExenta = data.TipoExenta || ''
        this.formStepVertifactu.tipoNoExenta = data.TipoNoExenta || ''
        this.formStepVertifactu.tipoNoSujeta = data.TipoNoSujeta || ''
      }
    },
    resetFormCert: function () {
      this.file.name = null
      this.file.b64 = null
      this.formStepCertificado.password = ''
      this.dataCertificate = {
        issuer: '',
        nombre: '',
        fechaCaducidad: '',
        serial: '',
      }
      this.filePdf.name = null
      this.filePdf.b64 = null
      this.formStepCertificado.NombreApellidos = ''
      this.formStepCertificado.NIF = ''
      this.formStepCertificado.Municipio = ''
      this.formStepCertificado.ViaPublica = ''
      this.formStepCertificado.NumeroViaPublica = ''
      this.$refs.ruleformStepCertificado.clearValidate()
      this.checkPreloadPdf = false
    },
    setDataStepTutorial: function (data) {
      if (data) {
        this.videoIdLink = data
      }
    },
    setDataStepInitial (data) {
      if (data) {
        this.videoIdLinkInitial = data
      }
    },
    base64ToBlob (base64, mime) {
      const byteCharacters = atob(base64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      return new Blob([byteArray], { type: mime })
    },
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleChangePdf: function (file) {
      this.$refs.uploadpdfref.clearValidate()
      this.filePdf.name = file.name
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.filePdf.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
    handleRemovePdf: function () {
      this.filePdf.name = null
      this.filePdf.b64 = null
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let res = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          res = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(res)
        }
      })
    },
    // Verifactu
    showPopover: function (id) {
      return id !== '01' && id !== '02'
    },
  }
}
</script>

<style scoped>

.el-upload-dragger {
    background-color: #fff;
    border: 1px
    dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-height: 100%;
}

.file-selected {
  color: rgb(90, 90, 90);
  text-transform: uppercase;
}
</style>
